<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <PaymentMethodeForm
      v-if="!isLoading"
      :paymentMethodeData="paymentMethodeData"
      :submitName="$t('edit')"
      v-on:addOrUpdatePaymentMethode="updatePaymentMethode"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import PaymentMethodeForm from "@/components/settings/settingsOther/paymentMethodes/PaymentMethodeForm.vue";
import PaymentMethode from "@/models/settings/settingsOther/paymentMethodes/PaymentMethode";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "PaymentMethodeEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    PaymentMethodeForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      paymentMethodeData: new PaymentMethode(),
      paymentMethodeToken: this.$route.params.paymentMethodeToken,
    };
  },
  methods: {
    async getPaymentMethodeDetails() {
      this.isLoading = true;
      this.paymentMethodeData.paymentMethodeToken = this.paymentMethodeToken;
      try {
        let response = await this.paymentMethodeData.getPaymentMethodeDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.paymentMethodeData.fillData(response.data.paymentMethodeData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.paymentMethodeData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.paymentMethodeData = null;
      }
      this.isLoading = false;
    },
    async updatePaymentMethode() {
      this.isLoading = true;
      try {
        let response = await this.paymentMethodeData.addOrUpdatePaymentMethode(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "PaymentMethodes" });
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getPaymentMethodeDetails();
  },
};
</script>

<style scoped lang="scss"></style>
